import { TYPE_IDS } from '../../constants/apiV4TypeIds';
import { IUser } from '../../types/IUser';
import { fetchEntity } from '../Designer/api';

// THIS is how our API handles "WHO AM I?"
// Details: https://synergiesio.sharepoint.com/:x:/r/sites/development/_layouts/15/Doc.aspx?sourcedoc=%7B376AC3B8-D047-4085-BA3A-7397DBECEDC2%7D&file=Entity%20Ids%20%26%20Parent.xlsx&action=default&mobileredirect=true&cid=e7547fbf-fffc-4705-80e5-8c72983485d9
export const fetchCurrentUserData = () => fetchEntity<IUser>(TYPE_IDS.User, '00000000-0000-0000-0000-000000000000')();

export const fetchUserData = (userId: string) => fetchEntity<IUser>(TYPE_IDS.User, userId)();
